import React from 'react'
import { useSelector } from 'react-redux'

import { getAction } from '../../../../ducks/actions'
import Property from './Property'

import styles from './Steps.module.css'

export default function APIStep({ actionId, step }) {
  const action = useSelector(getAction(actionId))

  return (
    <>
      <h2>API Call</h2>
      <div className={styles.properties}>
        <div>
          <Property
            label="Method"
            value={(step.method || '').toUpperCase()}
            action={action}
          />
        </div>
        <div>
          <Property label="URL" value={step.url} action={action} />
        </div>
      </div>
    </>
  )
}
